import Home from "./routes/home";
import "./style/index.css";
import { ComputeProvider } from "./store/ComputeContext";
import { UIProvider } from "./store/UIContext";

function App() {
  return (
    <UIProvider>
      <ComputeProvider>
        <Home></Home>
      </ComputeProvider>
    </UIProvider>
  );
}

export default App;
